import script from "./TaxResults.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaxResults.vue?vue&type=script&setup=true&lang=ts"

import "./TaxResults.vue?vue&type=style&index=0&id=2573325a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2573325a"]])

export default __exports__